import * as React from "react";

const SvgKomb2 = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="344"
    height="200"
    fill="none"
    viewBox="0 0 344 200"
    {...props}
  >
    <path fill={rackColor} d="M0 0h344v200H0z"></path>
        <path
      fill="none"
      stroke="black"
      strokeWidth="0.8"
      d="M0 0h344v200H0z"    />
    <path fill="#D7EAFF" d="M14 45h315.333v85H14z"></path>
  </svg>
);

export default SvgKomb2;
